import { render, staticRenderFns } from "./LessonNote.vue?vue&type=template&id=47ca5768&"
import script from "./LessonNote.vue?vue&type=script&lang=js&"
export * from "./LessonNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports